export enum AppClientValue {
  Teacher = 'teacher',
  Student = 'student',
}

function normalizeClient(client?: string | null) {
  return client?.trim().toLowerCase();
}

export default function getAppClient(): AppClientValue {
  const clientFromEnv = normalizeClient(process.env.APP_CLIENT);
  if (clientFromEnv === AppClientValue.Teacher) {
    return AppClientValue.Teacher;
  }
  if (clientFromEnv === AppClientValue.Student) {
    return AppClientValue.Student;
  }

  const host = window.location.hostname.toLowerCase();
  if (host.includes('student')) {
    return AppClientValue.Student;
  }

  return AppClientValue.Teacher;
}
